import { Label } from "@mui/icons-material";
import { Button } from "@mui/material";
import { DataGrid, GridColumns, GridRenderCellParams } from "@mui/x-data-grid";
import React, { FunctionComponent, useEffect, useState } from "react";
import { AppStore } from "../../../../AppStore";
import { GridCard } from "../../../../components/gridManager/components/GridCard";
import { IGridComponent } from "../../../../components/gridManager/GridManager";
import {
  User,
  UserRole,
  UserRoleRender,
} from "../../../../services/user/models/User";
import { UserService } from "../../../../services/user/UserService";
import styles from "../styles/Components.css";
import { AddUserToCompanyForm } from "./AddUserToCompanyForm";

interface Props extends IGridComponent {}

const UsersList: FunctionComponent<Props> = (props) => {
  const [companies, companiesActions] = AppStore.companies.use();
  const [state, actions] = AppStore.users.use();
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const columns: GridColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 160,
    },
    {
      field: "role",
      headerName: "Role",
      width: 130,
      valueFormatter: (params) => UserRoleRender[params.value as UserRole],
    },
    {
      field: "id",
      headerName: "ID",
      width: 210,
    },
    {
      field: "delete",
      headerName: "",
      width: 120,
      renderCell: (params: GridRenderCellParams) => (
        <Button onClick={() => handleRemove(params.row)} color="error">
          remove
        </Button>
      ),
    },
  ];

  const handleRemove = (user) => {
    if (user && companies.highlighted)
      UserService.removeFromCompany(user, companies.highlighted.id)
        .then(() => actions.updateParentCollection(companies.highlighted))
        .then(() => actions.updateCollection())
        .catch(console.log);
  };

  const handleUsers = () => {
    if (companies.highlighted)
      actions
        .getCachedParentCollection(companies.highlighted)
        .then(setUsers)
        .then(() => setLoading(false))
        .catch(console.log);
  };

  useEffect(() => {
    setLoading(true);
    handleUsers();
  }, [companies.highlighted]);

  useEffect(() => {
    if (!loading) handleUsers();
  }, [state.parentCollection]);

  return (
    <GridCard
      gridIndex={props.gridIndex}
      loading={loading}
      icon="./icons/group.png"
      title="Users"
      utility={<AddUserToCompanyForm />}
    >
      <div className={styles.listContainer}>
        <DataGrid
          rows={users}
          columns={columns}
          loading={loading}
          rowHeight={30}
          headerHeight={30}
          sx={{
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#e9e9e9",
            },
          }}
          hideFooter
        />
      </div>
    </GridCard>
  );
};

export default UsersList;
